<template>
    <div class="chart-block">
        <!-- Legend -->
        <div class="legend-row">
            <span v-for="(item, i) in legendItems" :key="i" class="legend-item">
                <span class="legend-sq" :style="{ background: item.color }"></span>
                {{ item.label }}
            </span>
        </div>
        <Chart
            v-if="hasData"
            type="bar"
            :data="chartData"
            :options="chartOptions"
            class="w-full"
        />
        <div v-else class="chart-empty">Sem dados</div>
    </div>
</template>

<script>
import SafeChart from '@/components/SafeChart.vue';

const DATASET_COLORS = ['#3b82f6', '#e11d48', '#f59e0b'];

export default {
    name: 'ActiveBarContratosMes',
    components: { Chart: SafeChart },
    props: {
        rawData: { type: Object, default: () => ({}) }
    },
    computed: {
        hasData() {
            return this.rawData?.labels?.length && this.rawData?.datasets?.length;
        },
        legendItems() {
            if (!this.hasData) return [];
            return (this.rawData.datasets || []).map((ds, i) => ({
                label: ds.label,
                color: DATASET_COLORS[i] || '#6b7280'
            }));
        },
        chartData() {
            if (!this.hasData) return {};
            const datasets = this.rawData.datasets.map((ds, i) => ({
                ...ds,
                backgroundColor: DATASET_COLORS[i] || '#6b7280',
                borderColor: 'transparent',
                borderRadius: 4,
                barPercentage: 0.55,
                categoryPercentage: 0.75,
            }));
            return { ...this.rawData, datasets };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        backgroundColor: 'rgba(20,20,20,0.95)',
                        titleColor: '#e6edf3',
                        bodyColor: '#8b949e',
                        cornerRadius: 6,
                        padding: 8,
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: { color: '#8b949e', font: { size: 10 }, maxRotation: 30 }
                    },
                    y: {
                        grid: { color: 'rgba(255,255,255,0.06)', drawBorder: false },
                        ticks: { color: '#8b949e', font: { size: 11 } }
                    }
                }
            };
        }
    }
}
</script>

<style scoped>
.chart-block { height: 260px; display: flex; flex-direction: column; gap: 8px; }
.chart-block :deep(canvas) { flex: 1; min-height: 0; }
.chart-empty { flex: 1; display: flex; align-items: center; justify-content: center; color: #6b7280; }

.legend-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    padding-bottom: 2px;
}
.legend-item {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 0.78rem;
    color: #c9d1d9;
}
.legend-sq {
    width: 22px;
    height: 8px;
    border-radius: 3px;
    flex-shrink: 0;
}
</style>
